export class BaseChartRequest {
    fromDate?: Date;
    toDate?: Date;
    userId?: string;
    customerId?: number;
}
